export default __webpack_public_path__ + "static/logo-8df9d5bac8c32bc234c21027194c0b25.png";